import { MenuItem, Select, SxProps } from '@mui/material';

interface Values {
	value: string | number;
	label: string | number;
}

interface Props {
	title: string;
	values: Values[];
	value: string | string[] | number | number[] | null;
	setState?: (value: number | string) => void;
	width?: string;
	disabled?: boolean;
	backgroundColor?: string;
	fontSize?: string;
	titleColor?: string;
	fontWeight?: string;
	className?: string;
	isMulti?: boolean;
	onChange?: () => void;
	labelFontSize?: string;
	selectSx?: SxProps;
	errorMessage?: string;
	required?: boolean;
}

const SimpleSelect = ({
	title,
	values,
	value,
	setState,
	width,
	backgroundColor,
	disabled,
	fontSize,
	titleColor,
	fontWeight,
	className,
	isMulti = false,
	onChange,
	errorMessage,
	selectSx,
	labelFontSize = '12px',
	required = false,
}: Props) => {
	if (isMulti) {
		return (
			<div className={className}>
				<div
					className={`mb-1 ${titleColor || 'text-[#4A4A4A]'} ${fontWeight || ''}`}
					style={{ fontSize: labelFontSize }}
				>
					{title}
					{required && <span className="text-red">*</span>}
				</div>
				<Select
					multiple={isMulti}
					sx={{
						width: `${width || '27rem'}`,
						height: '2rem',
						fontSize: `${fontSize || '12px'}`,
						background: backgroundColor || '',
						fontFamily: 'Graphie, sans-serif',
						...selectSx,
					}}
					value={value}
					disabled={setState === undefined || disabled}
					onChange={onChange}
					displayEmpty
					inputProps={{ 'aria-label': 'Without label' }}
				>
					{values.map((el) => {
						return (
							<MenuItem
								sx={{
									fontSize: labelFontSize,
									fontFamily: 'Graphie, sans-serif',
								}}
								value={el.value}
								key={el.label}
							>
								{el.label}
							</MenuItem>
						);
					})}
				</Select>
				{errorMessage && <p className="text-[10px] text-red">{errorMessage}</p>}
			</div>
		);
	} else {
		return (
			<div className={className}>
				<div
					className={`mb-1 ${titleColor || 'text-[#4A4A4A]'} ${fontWeight || ''}`}
					style={{ fontSize: labelFontSize }}
				>
					{title}
					{required && <span className="text-red">*</span>}
				</div>
				<Select
					sx={{
						width: `${width || '27rem'}`,
						height: '2rem',
						fontSize: `${fontSize || '12px'}`,
						background: backgroundColor || '',
						fontFamily: 'Graphie, sans-serif',
						...selectSx,
					}}
					value={value}
					disabled={setState === undefined || disabled}
					onChange={(e) => {
						setState?.(e.target.value as number | string);
					}}
					displayEmpty
					inputProps={{ 'aria-label': 'Without label' }}
				>
					{values.map((el) => {
						return (
							<MenuItem
								sx={{
									fontSize: fontSize,
									fontFamily: 'Graphie, sans-serif',
								}}
								value={el.value}
								key={el.label}
							>
								{el.label}
							</MenuItem>
						);
					})}
				</Select>
				{errorMessage && <p className="text-[10px] text-red">{errorMessage}</p>}
			</div>
		);
	}
};

export default SimpleSelect;
